interface IVesselImageCopyrightProps {
	sourceUrl: string;
	vesselName: string;
}

const VesselImageCopyright: React.FC<IVesselImageCopyrightProps> = ({ ...props }) => {
	const parseName = (filename: string): string => {
		if (!filename) {
			return '';
		}
		const start = filename.indexOf('_') + 1; // Start after the underscore
		const end = filename.lastIndexOf('.'); // Stop before the file extension
		return filename.substring(start, end);
	};

	return (
		<div>
			{((!props.vesselName || props.vesselName === 'no_vessel_image') && (
				<span className="text-xs italic text-msi-midblue-color-500">No Image Found</span>
			)) || (
				<div>
					<span className="text-xs italic text-msi-midblue-color-500">Image&nbsp;&copy;&nbsp;</span>
					<span className="text-xs italic cursor-pointer hover:underline text-msi-midblue-color-500 pr-1">
						<a href={props.sourceUrl} target="_blank" rel="noopener noreferrer">
							{parseName(props.vesselName)}
						</a>
					</span>
				</div>
			)}
		</div>
	);
};
export default VesselImageCopyright;
